import React, { useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import config from 'config';
import { useSelector } from 'react-redux';
import {
  NetworkRoutesPage,
  NetworkEvaluatorPage,
  NetworkSourcePage,
  navigationItemsIds,
  NetworkStateProvider,
} from '@ontruck/fe-core';
import { useTopBarMenuButtonStateHook } from '../../components/Topbar/providers/top-bar-menu-button-state-hook';

import '../../modules/emergencies/components/ui/emergencyPopup.css';
import { captureMessage } from 'modules/sentry';

export function NetworkModule({ match }) {
  const token = useSelector((state) => state?.user?.access_token);
  const email = useSelector((state) => state?.user?.email);
  const { open, toggle } = useTopBarMenuButtonStateHook();
  const history = useHistory();

  useEffect(() => {
    captureMessage(`User ${email} is accessing network module`);
  }, [email]);

  let networkConfig = {
    apiBase: `${config.BASE_URL}`,
    token,
  };

  const handleClickLeftSidebarNavigationItem = (navigationItemId) => {
    if (navigationItemId === navigationItemsIds.ROUTES) {
      history.push(`${match?.url}/routes`);
    }

    if (navigationItemId === navigationItemsIds.EVALUATOR) {
      history.push(`${match?.url}/evaluator`);
    }

    if (navigationItemId === navigationItemsIds.SOURCE) {
      history.push(`${match?.url}/source`);
    }
  };

  const handleClickDelegation = () => {
    history.push(`${match?.url}/routes`);
  };

  const handleClickLaunchEvaluation = () => {
    history.push(`${match?.url}/evaluator`);
  };

  return (
    <NetworkStateProvider config={networkConfig}>
      <Switch>
        <Route exact path={`${match?.url}/evaluator`}>
          <NetworkEvaluatorPage
            config={networkConfig}
            leftPanelIsOpen={open}
            toggleLeftPanelIsOpen={toggle}
            onClickLeftSidebarNavigationItem={handleClickLeftSidebarNavigationItem}
            onClickDelegation={handleClickDelegation}
          />
        </Route>
        <Route exact path={`${match?.url}/routes`}>
          <NetworkRoutesPage
            config={networkConfig}
            leftPanelIsOpen={open}
            toggleLeftPanelIsOpen={toggle}
            onClickLeftSidebarNavigationItem={handleClickLeftSidebarNavigationItem}
          />
        </Route>
        <Route exact path={`${match?.url}/source`}>
          <NetworkSourcePage
            config={networkConfig}
            leftPanelIsOpen={open}
            toggleLeftPanelIsOpen={toggle}
            onClickLeftSidebarNavigationItem={handleClickLeftSidebarNavigationItem}
            onClickLaunchEvaluation={handleClickLaunchEvaluation}
          />
        </Route>
      </Switch>
    </NetworkStateProvider>
  );
}
